import { Alert } from "antd";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CurrencyFormatter from "../../../../components/CurrencyFormatter";

const WalletDetails = ({ balance, totalBillingAmount }) => {
  const { t } = useTranslation();

  return (
    <>
      {balance && (
        <>
          <div
            style={{
              textAlign: "center",
              color: "#ffffff",
              backgroundColor: "#6301f2",
              padding: "10px",
            }}
          >
            {t("wallet_details")}
          </div>
          {balance.amount < totalBillingAmount * 3 && (
            <Alert
              message={
                t("your_balance_is_low_please_recharge_minimum") +
                " " +
                totalBillingAmount * 15
              }
              type="warning"
              showIcon
            />
          )}
          <div style={{ backgroundColor: "#fff", padding: "20px" }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                {t("available_credit")} <br />{" "}
                <h2>
                  <CurrencyFormatter value={balance.amount} />
                </h2>
              </div>
            </div>
            <div>
              {balance.expiry_date &&
                t("balance_validity") +
                  " : " +
                  moment(balance.expiry_date).format("MMM. D, YYYY")}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default WalletDetails;
